export type UserRole = 'admin' | 'user' | 'people_only';

export type CurrentUserRoleLike =
  | {
      role?: string;
      application_access?: { allowed: boolean };
      access?: string;
      feature_flags?: Record<string, boolean>;
    }
  | null
  | undefined;

export const PEOPLE_ONLY_ROLE: UserRole = 'people_only';
export const AGENT_PAGE_FEATURE_KEY = 'agent_page';
export const PEOPLE_ONLY_ALLOWED_PATHS = ['/people', '/lists', '/profile'] as const;

export const isAdminUser = (currentUser: CurrentUserRoleLike) =>
  currentUser?.role === 'admin' || currentUser?.access === 'admin';

export const isPeopleOnlyUser = (currentUser: CurrentUserRoleLike) =>
  currentUser?.role === PEOPLE_ONLY_ROLE;

export const isPeopleOnlyAllowedPath = (pathname: string) => {
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  return PEOPLE_ONLY_ALLOWED_PATHS.some((path) => path === normalizedPath);
};

export const canAccessNonPeoplePages = (currentUser: CurrentUserRoleLike) =>
  !isPeopleOnlyUser(currentUser);

export const getDefaultAuthenticatedPath = (
  currentUser: CurrentUserRoleLike,
) => currentUser?.application_access?.allowed === false ? '/subscription-required' : (isPeopleOnlyUser(currentUser) ? '/people' : '/dashboard');

export const canAccessProductSurfaces = (currentUser: CurrentUserRoleLike) =>
  !isPeopleOnlyUser(currentUser);

export const canAccessAccountsPage = (currentUser: CurrentUserRoleLike) =>
  !isPeopleOnlyUser(currentUser);

export const canAccessMapPage = (currentUser: CurrentUserRoleLike) =>
  !isPeopleOnlyUser(currentUser);

export const canAccessAgentPage = (currentUser: CurrentUserRoleLike) =>
  !isPeopleOnlyUser(currentUser) && currentUser?.feature_flags?.[AGENT_PAGE_FEATURE_KEY] !== false;
